export const LANGUAGES = [
  { code: "en", dir: "ltr" },
  { code: "ar", dir: "rtl" },
  { code: "he", dir: "rtl" },
];

export const translations = {
  en: {
    languageName: "English",
    brand: "Salatty",
    brandSuffix: "for Business",
    heroBadge: "Salatty Partner Program",
    heroTitle: "Grow Your Business with Salatty",
    heroSubtitle:
      "Join our network of trusted merchants and reach thousands of new customers. Tell us about your business and our team will help you get set up in no time.",
    heroCta: "Apply Now",
    highlightsEyebrow: "Why partner with Salatty",
    feature1Title: "Reach More Customers",
    feature1Desc:
      "Get discovered by thousands of shoppers actively browsing on Salatty.",
    feature2Title: "Simple Order Management",
    feature2Desc:
      "Track and manage every order from one easy-to-use dashboard.",
    feature3Title: "Fast, Reliable Delivery",
    feature3Desc:
      "Our delivery network gets your products to customers quickly.",
    formTitle: "Apply to Become a Partner",
    formSubtitle:
      "Fill in your details below and our team will contact you shortly.",
    fullNameLabel: "Full Name",
    phoneLabel: "Phone Number",
    emailLabel: "Email",
    businessNameLabel: "Business Name",
    cityLabel: "City",
    messageLabel: "Tell us about your business",
    messageHelper: "What do you sell, and anything else we should know?",
    submitLabel: "Send Request",
    submittingLabel: "Sending...",
    successMessage:
      "Thanks for reaching out! Our team will contact you shortly.",
    genericError:
      "Something went wrong while sending your request. Please try again.",
    footerText: "Salatty. All rights reserved.",
  },
  ar: {
    languageName: "العربية",
    brand: "Salatty",
    brandSuffix: "للأعمال",
    heroBadge: "برنامج شركاء Salatty",
    heroTitle: "نمِّ أعمالك مع Salatty",
    heroSubtitle:
      "انضم إلى شبكة تجارنا الموثوقين وصِل إلى آلاف العملاء الجدد. أخبرنا عن عملك وسيتواصل معك فريقنا لمساعدتك على البدء بسرعة.",
    heroCta: "قدّم طلبك الآن",
    highlightsEyebrow: "لماذا تشاركنا في Salatty",
    feature1Title: "الوصول إلى المزيد من العملاء",
    feature1Desc: "اجعل متجرك مرئيًا لآلاف المتسوقين النشطين على Salatty.",
    feature2Title: "إدارة طلبات بسيطة",
    feature2Desc: "تابع وأدر كل طلب من لوحة تحكم سهلة الاستخدام.",
    feature3Title: "توصيل سريع وموثوق",
    feature3Desc: "تُوصل شبكة التوصيل لدينا منتجاتك إلى العملاء بسرعة.",
    formTitle: "قدّم طلبًا لتصبح شريكًا",
    formSubtitle: "املأ بياناتك أدناه وسيتواصل معك فريقنا قريبًا.",
    fullNameLabel: "الاسم الكامل",
    phoneLabel: "رقم الهاتف",
    emailLabel: "البريد الإلكتروني",
    businessNameLabel: "اسم النشاط التجاري",
    cityLabel: "المدينة",
    messageLabel: "أخبرنا عن عملك",
    messageHelper: "ماذا تبيع، وأي شيء آخر يجب أن نعرفه؟",
    submitLabel: "إرسال الطلب",
    submittingLabel: "جارٍ الإرسال...",
    successMessage: "شكرًا لتواصلك معنا! سيتواصل معك فريقنا قريبًا.",
    genericError: "حدث خطأ أثناء إرسال طلبك. يرجى المحاولة مرة أخرى.",
    footerText: "Salatty. جميع الحقوق محفوظة.",
  },
  he: {
    languageName: "עברית",
    brand: "Salatty",
    brandSuffix: "לעסקים",
    heroBadge: "תוכנית השותפים של Salatty",
    heroTitle: "הצמיחו את העסק שלכם עם Salatty",
    heroSubtitle:
      "הצטרפו לרשת הסוחרים המהימנים שלנו והגיעו לאלפי לקוחות חדשים. ספרו לנו על העסק שלכם והצוות שלנו יעזור לכם להתחיל במהירות.",
    heroCta: "הגישו בקשה עכשיו",
    highlightsEyebrow: "למה להצטרף ל-Salatty",
    feature1Title: "הגיעו ליותר לקוחות",
    feature1Desc: "התגלו על ידי אלפי קונים הגולשים ב-Salatty.",
    feature2Title: "ניהול הזמנות פשוט",
    feature2Desc: "עקבו ונהלו כל הזמנה מלוח בקרה נוח לשימוש.",
    feature3Title: "משלוח מהיר ואמין",
    feature3Desc: "רשת המשלוחים שלנו מביאה את המוצרים שלכם ללקוחות במהירות.",
    formTitle: "הגישו בקשה להצטרפות כשותפים",
    formSubtitle: "מלאו את הפרטים שלכם למטה והצוות שלנו יצור איתכם קשר בקרוב.",
    fullNameLabel: "שם מלא",
    phoneLabel: "מספר טלפון",
    emailLabel: "אימייל",
    businessNameLabel: "שם העסק",
    cityLabel: "עיר",
    messageLabel: "ספרו לנו על העסק שלכם",
    messageHelper: "מה אתם מוכרים, ומה עוד כדאי שנדע?",
    submitLabel: "שליחת הבקשה",
    submittingLabel: "שולח...",
    successMessage: "תודה שפניתם אלינו! הצוות שלנו יצור איתכם קשר בקרוב.",
    genericError: "אירעה שגיאה בשליחת הבקשה. אנא נסו שוב.",
    footerText: "Salatty. כל הזכויות שמורות.",
  },
};
